/* BOLTRON (page.boltron) · 08 Other watches carousel. snippets/boltron-others.liquid.
   Native scroll-snap row; arrows step one card, one dot per card. Controls
   are hidden (.is-static) when every card already fits. */
(function () {
  Array.prototype.forEach.call(document.querySelectorAll('[data-bh-others]'), function (root) {
    var track = root.querySelector('[data-bh-others-track]');
    var items = Array.prototype.slice.call(root.querySelectorAll('[data-bh-others-item]'));
    var dotsBox = root.querySelector('[data-bh-others-dots]');
    var prev = root.querySelector('[data-bh-others-prev]');
    var next = root.querySelector('[data-bh-others-next]');
    if (!track || !items.length) return;
    var motion = window.matchMedia('(prefers-reduced-motion: reduce)');

    var dots = items.map(function (item, index) {
      var dot = document.createElement('button');
      dot.type = 'button';
      dot.className = 'bh-ot__dot';
      dot.setAttribute('aria-label', 'Show watch ' + (index + 1) + ' of ' + items.length);
      dot.addEventListener('click', function () { go(index); });
      if (dotsBox) dotsBox.appendChild(dot);
      return dot;
    });

    var step = function () {
      return items.length > 1 ? items[1].offsetLeft - items[0].offsetLeft : track.clientWidth;
    };
    var current = function () {
      return Math.max(0, Math.min(items.length - 1, Math.round(track.scrollLeft / step())));
    };
    var go = function (index) {
      index = Math.max(0, Math.min(items.length - 1, index));
      track.scrollTo({ left: items[index].offsetLeft - items[0].offsetLeft, behavior: motion.matches ? 'auto' : 'smooth' });
    };

    var sync = function () {
      var maxScroll = track.scrollWidth - track.clientWidth;
      var fits = maxScroll <= 2;
      root.classList.toggle('is-static', fits);
      var index = current();
      var atEnd = track.scrollLeft >= maxScroll - 2;
      dots.forEach(function (dot, i) {
        dot.setAttribute('aria-current', i === index ? 'true' : 'false');
      });
      if (prev) prev.disabled = track.scrollLeft <= 2;
      if (next) next.disabled = atEnd;
    };

    if (prev) prev.addEventListener('click', function () { go(current() - 1); });
    if (next) next.addEventListener('click', function () { go(current() + 1); });
    track.addEventListener('keydown', function (event) {
      if (event.key === 'ArrowRight') { event.preventDefault(); go(current() + 1); }
      else if (event.key === 'ArrowLeft') { event.preventDefault(); go(current() - 1); }
    });

    var frame = 0;
    var schedule = function () {
      window.cancelAnimationFrame(frame);
      frame = window.requestAnimationFrame(sync);
    };
    track.addEventListener('scroll', schedule, { passive: true });
    window.addEventListener('resize', schedule);
    root.classList.add('is-ready');
    sync();
  });
})();
